import React from "react";
import PropTypes from "prop-types";
import { PatternFormat } from 'react-number-format';
import TextField from "./TextField";

const PatternFormatRegular = React.forwardRef((props, ref) => {
  let rawValue = props.value;
  const { onChange, onBlur, ...other } = props;

  return (
    <PatternFormat
      getInputRef={ref}
      onValueChange={values => {
        //const realValue = values.value ? other.decimalScale ? parseFloat(values.value) : parseInt(values.value, 10) : '';
        //if (realValue !== rawValue) { //TODO: Revisar, ya que aún que no generar el error, tiene un comportamiento extraño
        //rawValue = values.value;
        onChange({
          target: {
            value: values.value
          }
        });
        //}
      }}
      onBlur={() => {
        onBlur({
          target: {
            value: rawValue
          }
        });
      }}
      {...other}
    />
  )
});

const PatternField = React.forwardRef((props, ref) => {
  const { formatter = {}, InputProps, ...others } = props;
  return <TextField
    {...others}
    ref={ref}
    InputProps={{
      inputComponent: PatternFormatRegular,
      inputProps: { ...formatter },
      ...InputProps,
    }} />;
});

PatternField.propTypes = {
  formatter: PropTypes.object,
};

PatternField.defaultProps = {
  margin: "normal",
};

PatternField.displayName = 'PatternField';

export default PatternField;